import axiosInstance, { axiosNAKBHOInstance } from "../../../../interceptor/intercetptor-inctence";


// export const getParameter = (data) => {
// 	return axiosNAKBHOInstance.post(`/view-parame-list`, data)
// }

export const getParameter = (data) => {
	return axiosNAKBHOInstance.post(`api/parameters/list`, data)
}

export const statusParameter = (id) => {
    return axiosInstance.post(`api/parameters/change-status?parameterId=${id}`,{});
}

export const deleteParameter = (id) => {
    return axiosInstance.post(`api/parameters/delete?parameterId=${id}`,{});
}

export const addParameter = (formData) => {
    return axiosInstance.post(`api/parameters/create`,formData);
}

export const updateParameter = (formData) => {
    return axiosInstance.post(`api/parameters/update`,formData);
}

export const viewParameter = (id) => {
    return axiosInstance.post(`api/parameters/view?parameterId=${id}`,{});
}

export const globalParameter = () => {
    return axiosInstance.post(`api/global-master/parameter_master`,{});
}

export const addGlobalParameter = (formData) => {
    return axiosInstance.post(`api/global-master/import_parameter_master`,formData);
}
